// extracted by mini-css-extract-plugin
export default {"content":"LuckyColorPage_content__m5tMz","colorContainer":"LuckyColorPage_colorContainer__fH5Qw","circle":"LuckyColorPage_circle__06fAQ"};